
import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';

export default class Notification extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/notification/get", {
            id: this.getCurrentFormId(),
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/notification/save", {
            id: this.state.data.record.id,
            title: this.state.data.record.title,
            content: this.state.data.record.content
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                this.setState({
                    redirect: '/notifications'
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    renderForm() {
        return (
            <form onSubmit={e => this.save(e)}>
                <div className="row">
                    <div className="col-md-12">
                        <div className="container" id="invoiceCustomerBox">
                            <div className="form-group">
                                <label>عنوان</label>
                                <input className="form-control" type="text" defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} />
                            </div>
                            <div className="form-group">
                                <label>متن اطلاعیه</label>
                                <textarea className="form-control" type="text" defaultValue={this.state.data.record.content} onChange={e => this.state.data.record.content = e.target.value}></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <button type="submit" className="btn btn-primary">ذخیره</button>
                </div>
            </form>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : this.renderForm();

        return (
            <div>
                {this.state.lockScreen === 1 && this.lockScreen()}
                {this.getToastContainer()}
                {contents}
            </div>
        );
    }
}